require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



//////////////////
// WEBPACK FOOTER
// /usr/src/app/~/core-js/library/fn/array/from.js
// module id = 454
// module chunks = 168707334958949